import { render, staticRenderFns } from "./CircleSlice3.vue?vue&type=template&id=1fce5ff4&"
import script from "./CircleSlice3.vue?vue&type=script&lang=js&"
export * from "./CircleSlice3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports